import { Injectable } from "@angular/core";
import { GridLayoutService } from "@irb-common/interfaces/grid-layout.service";
import { ComponentSecuritiesComponent } from '@irb/irb-editors/editor-security/component-securities/component-securities.component';
import { ComponentSecuritiesDeleteCellComponent } from '@irb/irb-editors/editor-security/component-securities/component-securities-delete-cell.component';
import { ComponentSecuritiesDeleteAllComponent } from '@irb/irb-editors/editor-security/component-securities/component-securities-delete-all.component';


@Injectable({
    providedIn: "root"
})
export class ComponentSecuritiesGridLayoutService implements GridLayoutService<ComponentSecuritiesComponent> {
    sizeFor: any;

    constructor() {}

    getFrameworkComponents() {
        return {
            "DeleteHeaderComponent": ComponentSecuritiesDeleteAllComponent,
            "DeleteCellComponent": ComponentSecuritiesDeleteCellComponent
        };
    }

    getColumnDefs(parent: ComponentSecuritiesComponent) {
        return [{
            headerName: "Delete All",
            headerComponent: "DeleteHeaderComponent",
            headerComponentParams: {
                message: "Remove ALL component securities from the group.",
                note: "When removing, you can: \n1) Extract them to individual profiles in the Security Profiles inventory (they will each take on the Trading Rules of this group profile). \n2) Discard it completely.",
                cancel: parent.cancelDelete.bind(parent),
                extractAll: parent.extractAll.bind(parent),
                deleteAll: parent.deleteAll.bind(parent)
            },
            cellRenderer : "DeleteCellComponent",
            cellRendererParams: {
                message: "Remove this component security from group.",
                note: "When removing you can: \n1) Extract it and add it as individual security in the security master (it will take on the trading rules of this group security). \n2) Discard it completely.",
                cancel: parent.cancelDelete.bind(parent),
                extract: parent.extract.bind(parent),
                delete: parent.delete.bind(parent)
            },
            resizable: false,
            minWidth: 25,
            maxWidth: 25,
            width: 25,
            pinned: "left",
            lockPosition: true
        },
        {
            headerName: "Symbol",
            field: "securitySymbol",
            pinned: "left",
            minWidth: 110,
            lockPosition: true
        },
        {
            headerName: "Description",
            field: "securityDescription",
            minWidth: 130,
            cellRenderer: 'cellRendererFormatter',
            lockPosition: true
        },
        {
            headerName: "Type",
            field: "securityType",
            minWidth: 100,
            cellRenderer: 'cellRendererFormatter',
            lockPosition: true
        }

        ];
    }

}
